'use client';

import type { Editor } from '@tiptap/react';
import { useEffect } from 'react';

// Shared hook for common editor effects
export const useTipTapEffects = (
  editor: Editor | null,
  value: string,
  setEditor: (editor: Editor | null) => void,
  options?: {
    checkFocus?: boolean;
  },
) => {
  // Set editor in context
  useEffect(() => {
    setEditor(editor);
    return () => setEditor(null);
  }, [editor, setEditor]);

  // Update content when value changes from outside
  useEffect(() => {
    if (editor && editor.getText() !== value && (!options?.checkFocus || !editor.isFocused)) {
      editor.commands.setContent(value);
    }
  }, [editor, value, options?.checkFocus]);
};
